"use client"

import { useState, FormEvent } from "react"

export default function FooterNewsletterForm() {
  const [email, setEmail] = useState("")
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle")
  const [message, setMessage] = useState("")

  async function handleSubmit(e: FormEvent) {
    e.preventDefault()
    setStatus("loading")
    try {
      const res = await fetch("/api/newsletter", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      })
      const data = await res.json()
      if (!res.ok) {
        setStatus("error")
        setMessage(data.error || "Something went wrong")
      } else {
        setStatus("success")
        setMessage(data.message)
        setEmail("")
      }
    } catch {
      setStatus("error")
      setMessage("Failed to subscribe. Please try again.")
    }
  }

  if (status === "success") {
    return <p className="text-white/90 text-sm">{message}</p>
  }

  return (
    <>
      <form onSubmit={handleSubmit} className="w-full max-w-md flex flex-col md:flex-row gap-4">
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="flex-1 bg-transparent border border-gray-600 px-4 py-3 text-white placeholder-gray-400 focus:outline-none focus:border-white transition-colors"
          required
        />
        <button
          type="submit"
          disabled={status === "loading"}
          className="bg-white text-black px-8 py-3 uppercase tracking-widest text-sm font-medium hover:bg-gray-200 transition-colors disabled:opacity-50"
        >
          {status === "loading" ? "..." : "Subscribe"}
        </button>
      </form>
      {status === "error" && (
        <p className="text-red-400 text-sm mt-2">{message}</p>
      )}
    </>
  )
}
